import React from "react";

const defaultGridClassName = "grid gap-4 md:grid-cols-3";

const FeatureToggleGrid = ({
  items = [],
  values = {},
  onChange,
  name,
  className = "",
  gridClassName = defaultGridClassName,
  labelClassName = "",
  disabled = false,
}) => {
  const handleChange = (event) => {
    if (typeof onChange !== "function") return;
    onChange(event);
  };

  return (
    <div className={[gridClassName, className].filter(Boolean).join(" ")}>
      {items.map((item) => {
        const itemName = item.name;
        const checked = Boolean(values?.[itemName]);
        const itemDisabled = disabled || Boolean(item.disabled);

        return (
          <label
            key={itemName}
            className={[
              "flex flex-col gap-2",
              itemDisabled ? "opacity-60" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <div
              className={[
                "flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300",
                labelClassName,
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <input
                type="checkbox"
                name={name ? `${name}.${itemName}` : itemName}
                checked={checked}
                onChange={handleChange}
                disabled={itemDisabled}
                className="h-4 w-4 rounded border-slate-300 text-[#4f46e5] focus:ring-[#4f46e5]"
              />
              <span>{item.label}</span>
            </div>
            {item.helper && (
              <span className="text-xs text-slate-500 dark:text-slate-400">
                {item.helper}
              </span>
            )}
          </label>
        );
      })}
    </div>
  );
};

export default FeatureToggleGrid;
